/**
 * WebP 转换配置选项
 * 根据 MinIO 文件上传接口文档定义
 */

// WebP 转换开关选项
export const convertOptions = [
  { label: '不转换（保持原格式）', value: false },
  { label: '转换为 WebP 格式', value: true }
]

// WebP 质量选项（根据接口文档）
export const qualityOptions = [
  {
    value: 'high',
    label: '高质量 (High)',
    description: '适合专业摄影、打印',
    fileSize: '较大',
    quality: '最佳'
  },
  {
    value: 'medium',
    label: '中等质量 (Medium) 推荐',
    description: '适合网站图片、社交媒体',
    fileSize: '中等',
    quality: '良好'
  },
  {
    value: 'low',
    label: '低质量 (Low)',
    description: '适合缩略图、预览图',
    fileSize: '较小',
    quality: '一般'
  },
  {
    value: 'smallest',
    label: '最小体积 (Smallest)',
    description: '适合图标、小图',
    fileSize: '最小',
    quality: '可接受'
  },
  {
    value: 'extreme',
    label: '极限压缩 (Extreme)',
    description: '极限压缩场景',
    fileSize: '极小',
    quality: '较差'
  }
]

// 默认配置
export const defaultWebpConfig = {
  convertToWebP: false,
  webpQuality: 'medium'
}
